.row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 16px 0;
  border-bottom: 1px solid var(--border);
}
.row:last-child { border-bottom: none; padding-bottom: 0; }
.row:first-child { padding-top: 0; }

.info { flex: 1; }

.label {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: var(--ink);
  cursor: pointer;
}

.hint {
  font-size: 13.5px;
  color: var(--muted);
  margin-top: 3px;
  line-height: 1.55;
}

.toggle {
  position: relative;
  width: 46px;
  height: 26px;
  flex-shrink: 0;
  cursor: pointer;
  margin-top: 1px;
}

.toggle input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.track {
  position: absolute;
  inset: 0;
  background: #bdc1c6;
  border-radius: 26px;
  transition: background 0.2s;
}

.toggle input:checked + .track {
  background: var(--blue);
}

.thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  box-shadow: var(--shadow-sm);
  transition: transform 0.2s;
  pointer-events: none;
}

.toggle input:checked ~ .thumb {
  transform: translateX(20px);
}
